import type { AlertColor } from '@mui/material/Alert';

const showUserMessage = (message: string, type: AlertColor = 'success') => {
  const event = new CustomEvent('OSTS_SHOW_USER_NOTIFICATION', {
    detail: {
      text: message,
      severity: type,
    },
  });

  window.dispatchEvent(event);
};

export default showUserMessage;
